import { combineReducers } from 'redux'
import { pocketsReducer } from './pocketsReducer'
import { generalReducer } from './generalReducer'

export const rootReducer = combineReducers({
  pockets: pocketsReducer,
  general: generalReducer,
})
